var FlashMessage = require('../modules/flash_message');
new FlashMessage();



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/flash_message.initializer.js